import { useMemo, useState } from 'react'
import {
  createCompanyGroup,
  updateCompanyGroup,
} from '../../../../../services/api/https/system/system.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE: 'Salvando Grupo de Empresas',
  UPDATE: 'Atualizando Grupo de Empresas',
  SUCCESS: 'Grupo de Empresas salvo com sucesso',
}

const INITIAL_STATE = {
  company: {
    id: 0,
    name: '',
  },
  updatedCompany: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useModalCompaniesGroup() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      createCompanyGroup(company) {
        createCompanyGroup({ name: company.name })
          .then(company =>
            setState(prevState => ({
              ...prevState,
              updatedCompany: company,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      updateCompanyGroup(company) {
        updateCompanyGroup(company)
          .then(company =>
            setState(prevState => ({
              ...prevState,
              updatedCompany: company,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onBtnSalvarClick(company) {
        if (company.id) {
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.UPDATE }))
        } else {
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE }))
        }
      },

      onInputChange(value) {
        setState(prevState => ({ ...prevState, company: { ...prevState.company, name: value } }))
      },

      onInit(data) {
        if (data) setState(prevState => ({ ...prevState, company: data }))
        else setState(prevState => ({ ...prevState, company: { ...INITIAL_STATE.company } }))
      },
    }
  }, [])

  return { state, localDispatch }
}
